import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Form, HStack, Link, Message, Panel, PanelGroup, Schema, Stack } from 'rsuite'
import Format, { PasswordField, TextField } from '@client/components/FormControls'
import { useAuth } from '@client/components/AuthProvider'
import ForgotPassword from './ForgotPassword'
import Overlay from './Overlay'

const { StringType } = Schema.Types

const formStyle = {
  backgroundColor: 'var(--color-2)',
  maxWidth: '90vw',
} as React.CSSProperties

type FormDataProps = { userName: string, password: string }

export default function Login() {
  const { t } = useTranslation()
  const format = Format()
  const formRef = useRef<FormDataProps>({ userName: '', password: '' })
  const { handleLogin } = useAuth()
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [openForget, setOpenForget] = useState(false)
  const [formData, setFormData] = useState<FormDataProps>({ userName: '', password: '' })

  const openForgettDialog = () => {
    setOpenForget(true)
  }

  async function handleSubmit(n: any, e: any) {
    e?.preventDefault()

    try {
      setError('')
      setLoading(true)
      await handleLogin(formData.userName, formData.password)
    } catch (err: any) {
      setError(t(err.message).toString())
    }
    finally {
      setLoading(false)
    }
  }

  const model = Schema.Model({
    // userName: StringType().pattern(
    //   /^[0-9a-z_\-.]{8}$/,
    //   t('Only 0-9 a-z _-. is allowed')
    // ).isRequired(format.required(t('Username'))),
    userName: StringType().isRequired(format.required(t('Username'))),
    password: StringType().isRequired(format.required(t('Password'))),
  });

  if (openForget) {
    return <ForgotPassword onClose={() => setOpenForget(false)} onBack={() => setOpenForget(false)} />
  }

  return (
    <>
      <Overlay>
        <Panel header={t('Log in')} bordered style={formStyle}>
          <PanelGroup>
            {error && <Message type="error">{error}</Message>}

            <Form
              id="login-form"
              layout="vertical"
              ref={formRef as any}
              onChange={setFormData as any}
              formValue={formData}
              model={model}
              onSubmit={handleSubmit}
            >
              <TextField name="userName" label={t('User name')} autoFocus={true} autoComplete='new-password' />
              <PasswordField name="password" label={t('Password')} autoComplete='new-password' />

              <HStack align="center" spacing={20} style={{ marginTop: 20, width: '100%' }}>
                <Button type="submit" appearance='ghost' disabled={loading}>{t('Log in')}</Button>
                <Stack.Item grow={1} textAlign="right">
                  <Link onClick={openForgettDialog}>{t('Forgot password?')}</Link>
                </Stack.Item>
              </HStack>
            </Form>
          </PanelGroup>
        </Panel>
      </Overlay>
    </>
  )
}